import Dialog from './Dialog.js';

class EulaDialog extends Dialog {
    static create(params) {
        return new EulaDialog(params);
    }

    static reset() {
        $('#eula-dialog').find('.eula_required').removeClass('eula_required');
    }

    getElForPackage(name) {
        var ids = {
            'AGS Historical Package': '.eula-ags',
            'Canada - Census': '.eula-environics',
            'Canada - DEP': '.eula-environics',
            'Canada - HEP': '.eula-environics',
            'Nielsen Scarborough': '.eula-nielsen-scarborough',
            'PRIZM Canada': '.eula-environics',
            'PRIZM': '.eula-prizm-us'
        };

        return this.find(ids[name]);
    }

    setPackages(packages) {
        packages.forEach(name => this.getElForPackage(name).addClass('eula_required'));

        return this;
    }
}

export default EulaDialog;